import styled from "styled-components"

export const StyledLayout = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0;
    padding: 0;
`